<template>
  <div class="layout">
    <Transition name="fade">
      <img
        v-if="qualificationFunction('showMainLogo')"
        class="main_logo"
        src="@/assets/images/MainLogo.png"
        alt="mainLogo"
      >
    </Transition>
    <Transition name="fade">
      <img
        v-if="qualificationFunction('showContecLogo')" class="logo"
        src="@/assets/images/ContecLogo.png"
        alt="Contec_Logo"
      >
    </Transition>
    <BackgroundImages />
    <Transition name="fade">
      <SatelliteInfo v-if="qualificationFunction('showSatelliteInfo')" />
    </Transition>
    <LoginPanel />
    <LoginedPanel />
    <SuccessModal />
    <FailedModal />
    <ForgotAccountModal />
    <LicenseModal />
    <HiddenPanel />
    <Transition name="fade">
      <button
        v-if="qualificationFunction('showImageModeBtn')" type="button"
        class="image_mode_btn"
        @click="imageModeToggle"
      >
        <span>
          <ImageModeSvg />
        </span>
        IMAGE MODE
      </button>
    </Transition>
    <Transition name="fade">
      <div v-if="isLoading" class="orbit_spinner_wrap">
        <OrbitSpinner
          :animationDuration="1200"
          fill="$color-white"
        />
      </div>
    </Transition>
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { OrbitSpinner } from 'epic-spinners';

import FailedModal from '@/components/common/modal/FailedModal.vue';
import ForgotAccountModal from '@/components/common/modal/ForgotAccountModal.vue';
import LicenseModal from '@/components/common/modal/LicenseModal.vue';
import SuccessModal from '@/components/common/modal/SuccessModal.vue';
import SatelliteInfo from '@/components/common/SatelliteInfo.vue';
import BackgroundImages from '@/components/desktop/BackgroundImages.vue';
import HiddenPanel from '@/components/desktop/HiddenPanel.vue';
import LoginedPanel from '@/components/desktop/LoginedPanel.vue';
import LoginPanel from '@/components/desktop/LoginPanel.vue';
import ImageModeSvg from '@/assets/images/Svgs/ImageModeSvg.vue';
import useCommonStore from '@/store/storeCommon';


const { isMainLogo, isImageMode, isLoading } = storeToRefs(useCommonStore());
const { imageModeToggle, windowSize, showPanel, showModal } = useCommonStore();

/**
 * 조건별 함수
 */
const qualificationFunction = (qualification: string): boolean => {
  switch (qualification) {
    case 'showMainLogo':
      return isMainLogo.value && !isImageMode.value;
    case 'showContecLogo':
      return !showPanel.isLeftPanel && !isImageMode.value;
    case 'showSatelliteInfo':
      return !showModal.isFail && !showModal.isForgotAccount;
    case 'showImageModeBtn':
      return isImageMode.value && (windowSize.width > 1280 && windowSize.height > 720);
    default:
      return false;
  }
};
</script>

<style scoped lang="scss">
@import '@/assets/css/_colors.scss';

.layout {
  width: 100vw;
  height: 100dvh;
  box-sizing: border-box;

  .logo {
    width: 80px;
    position: fixed;
    top: 31px;
    left: 54.5px;
    z-index: 200;
  }

  .main_logo, .show_panel_logo, .hide_panel_logo {
    transition: 0.8s;
    position: fixed;
    z-index: 200;
  }

  .main_logo {
    width: 580px;
    top: 47px;
    left: 50%;
    transform: translateX(-50%);
  }

  .fade-enter-active {
    transition: opacity 3s ease;
  }

  .image_mode_btn {
    fill: $color-debra;
    color: $color-debra;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 3.8px;
    font-size: 8px;
    position: absolute;
    left: 66px;
    bottom: 32.7px;
    z-index: 200;
  }

  .orbit_spinner_wrap {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(3px);
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;

    .orbit-spinner {
      width: 70px !important;
      height: 70px !important;
    }

    &.fade-enter-active,
    &.fade-leave-active {
      transition: opacity 0.3s ease;
    }
  }
}

@media (max-width: 540px) {
  .logo {
    width: 100px !important;
    left: 5% !important;;
  }
}
</style>
